/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import uploadFile from '@iconify/icons-ic/baseline-upload-file';
// material
import { Button } from '@mui/material';
//
import { ExcelRenderer } from 'react-excel-renderer';
import { useSnackbar } from 'notistack';
import { useTranslation } from '../../common/LocalizationProvider';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

UserImport.propTypes = {
  handleImportUser: PropTypes.func
};

export default function UserImport({ handleImportUser }) {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const fileHandler = (event) => {
    const fileObj = event.target.files[0];
    // just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        enqueueSnackbar(err, { variant: 'error' });
        return null;
      }
      const newRows = [];
      resp.rows.slice(1).map((row, index) => {
        if (row && row !== 'undefined') {
          newRows.push({
            id: index,
            name: row[0],
            prenom: row[1],
            adresse: row[2],
            adresseSuite: row[3],
            ville: row[4],
            codePostal: row[5],
            phone: row[6],
            email: row[7].toLowerCase(),
            statut: row[8].toLowerCase(),
            niveau: row[9]
          });
        }
        return null;
      });
      if (newRows.length === 0) {
        enqueueSnackbar(err, { variant: 'error' });
        return null;
      }
      handleImportUser(newRows);

      return null;
    });
  };

  return (
    <>
      <input
        accept=".csv,.xlsx"
        style={{ display: 'none' }}
        onChange={fileHandler}
        id="icon-button-file"
        type="file"
        multiple={false}
        value=""
      />
      <label htmlFor="icon-button-file">
        <Button disableRipple color="inherit" component="span" endIcon={<Icon icon={uploadFile} />}>
          {t('usersImport')}
        </Button>
      </label>
    </>
  );
}
